import { useTranslation } from 'react-i18next'
import { PublicPageControls } from '@/components/app/PublicPageControls'
import { StateSurface } from '@/components/app/StateSurface'

export function ForbiddenPage() {
  const { t } = useTranslation()

  return (
    <div className="relative">
      <div className="absolute right-4 top-4 z-20 sm:right-6 sm:top-6">
        <PublicPageControls />
      </div>
      <StateSurface
        variant="fullscreen"
        size="lg"
        tone="error"
        asset={
          <img
            src="/Uploads/acess_denied.webp"
            alt={t('system.forbidden.title')}
            className="h-56 w-56 md:h-64 md:w-64 object-contain"
          />
        }
        title={t('system.forbidden.title')}
        description={t('system.forbidden.description')}
        primaryAction={{
          label: t('system.forbidden.backToDashboard'),
          to: '/dashboard',
        }}
        secondaryAction={{
          label: t('system.forbidden.switchSession'),
          to: '/login',
        }}
      />
    </div>
  )
}
